import React from "react";
import {
  JobEntityType,
  JobEntityTypeColors,
} from "../../models/Jobs/JobEntityType";
import { Badge } from "../ui/badge";
import ConfirmationModal from "../common/ConfirmationModal";

interface ConfirmFilesDeletionConfig {
  title: string;
  jobEntityType: JobEntityType;
}

interface ConfirmFilesDeletionModalProps {
  open: boolean;
  entityKey: string;
  filePaths: string[];
  confirmFilesDeletionConfig: ConfirmFilesDeletionConfig;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmFilesDeletionModal: React.FC<ConfirmFilesDeletionModalProps> = ({
  open,
  entityKey,
  filePaths,
  confirmFilesDeletionConfig,
  onClose,
  onConfirm,
}: ConfirmFilesDeletionModalProps) => {
  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      message={`${confirmFilesDeletionConfig.title} ${entityKey}?`}
      statusColor="primary"
      buttonText="Confirm"
      maxWidth="35%"
    >
      <div className="mt-4 flex flex-row flex-wrap items-center justify-center gap-2">
        {filePaths.map((path) => (
          <Badge
            key={path}
            variant={JobEntityTypeColors[confirmFilesDeletionConfig.jobEntityType]}
          >
            {path}
          </Badge>
        ))}
      </div>
    </ConfirmationModal>
  );
};

export default ConfirmFilesDeletionModal;

export const CONFIRM_FILES_DELETION_CONFIGS = {
  CASE_FILES: {
    title: "Are you sure you want to delete case files from case",
    jobEntityType: JobEntityType.TemplateFile,
  },

  INTAKE_FILES: {
    title: "Are you sure you want to delete intake files from intake",
    jobEntityType: JobEntityType.TemplateFile,
  },

  PROVIDER_FILES: {
    title: "Are you sure you want to delete provider files from provider",
    jobEntityType: JobEntityType.TemplateFile,
  },

  FIRM_DOCUMENTS: {
    title: "Are you sure you want to delete firm documents from firm documents folder",
    jobEntityType: JobEntityType.TemplateFile,
  },

  TEMPLATE_FILES: {
    title: "Are you sure you want to delete template files from templates library",
    jobEntityType: JobEntityType.TemplateFile,
  },
} as const;
